import { VocabularyBundleStatus } from '@/types';
import { Button, CellProps, Icon } from '@prometheus/components';
import i18n from 'i18next';
import { FC } from 'react';

export const DownloadedBundlesCell: FC<CellProps<any>> = ({
  value: id,
  row,
}) => {
  const status = row.original.downloadStatus;

  return (
    <Button
      color="info"
      variant="contained"
      size="small"
      startIcon={<Icon iconName="download" sx={{ fontSize: 16 }} />}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        window.location.href = `/api/downloaded-vocabulary-bundles/${id}/download`;
      }}
      disabled={status !== VocabularyBundleStatus.DOWNLOADED}
    >
      {i18n.t('buttons.download')}
    </Button>
  );
};
